import React from 'react';

import { LoginCard } from '@/components/organisms/Auth';
import { LoginLayout } from '@/components/templates/LoginLayout';
import { CmBox, CmHeading, CmText } from '@/components/uiParts';
import { Form } from '@/pages/resend-email/components/Form';
import { routes } from '@/router';

import { useResendEmailRequest } from './hooks/useResendEmailRequest';

const ResendEmailPage = (): JSX.Element => {
  const resendEmailRequest = useResendEmailRequest();

  return (
    <LoginLayout>
      <LoginCard>
        <CmHeading size="md" fontSize="2xl" mb={5}>
          {routes.ResendEmail.title}
        </CmHeading>
        <CmBox mb={8}>
          <CmText>
            本登録用のURLを再送しますので、本登録メールを受信したメールアドレスを入力してください。
          </CmText>
        </CmBox>
        <Form onSubmit={resendEmailRequest} />
      </LoginCard>
    </LoginLayout>
  );
};

export default ResendEmailPage;
